// extracted by mini-css-extract-plugin
module.exports = {"iframe":"error_iframe__sqHPw"};